namespace RedBullMOBILE360.BulkSMS {
    @Serenity.Decorators.registerClass()
    export class BulkSMSExcelImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: BulkSMSExcelImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();

            this.form = new BulkSMSExcelImportForm(this.idPrefix);
            if (!Q.Authorization.hasPermission("BulkSMS:REDBULLMOB")) {
                let item = this.form.SenderId.items.filter(a => a.text == "REDBULLMOB")[0];
                this.form.SenderId.items.splice(this.form.SenderId.items.indexOf(item), 1);
            }
            if (!Q.Authorization.hasPermission("BulkSMS:RBMOBILE-AD")) {
                let item = this.form.SenderId.items.filter(a => a.text == "RBMOBILE-AD")[0];
                this.form.SenderId.items.splice(this.form.SenderId.items.indexOf(item), 1);
            }
        }

        protected getDialogTitle(): string {
            return "Import Numbers";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Send',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    BulkSMSService.ExcelImport({
                        FileName: this.form.FileName.value.Filename,
                        Message: this.form.Message.value,
                        IsMessageIncluded: this.form.IsMessageIncluded.value,
                        SendNow: this.form.SendNow.value,
                        SendDate: this.form.SendDate.value,
                        SendDate2: this.form.SendDate2.value,
                        SendDate3: this.form.SendDate3.value,
                        SenderId: parseInt(this.form.SenderId.value, 10)
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Message sent successfully");
                        if (response.Updated > 0) messageParts.push("<span style='color: red;'>Failed to send") + "</span>";
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        if (messageParts.length === 0) messageParts.push("No messages were imported.");
                        let message: string = messageParts.join(", ");

                        if (response.Inserted > 0) {
                            Q.success(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }
                        else if (response.Updated > 0) {
                            Q.warning(message,
                                {
                                    htmlEncode: false
                                });
                        } else {
                            Q.information(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }

                        this.IsDataImported = true;

                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}